import { Flex } from '@mantine/core';
import { CircleSVG, PlusCircleSVG } from 'common/assets';
import { themedStyled } from 'common/styles/styletron.theme';
import DeleteIconButton from 'components/common/delete-icon-button';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  OneQuarterContainer,
  SectionContainer as RawSectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { AgentFormType } from './form-type';
import { onAddNewContact } from '../hooks/use-get-default-values';

export default function PicInformationCard() {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<AgentFormType>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'contacts',
    keyName: 'customId',
  });

  const onAdd = () => append(onAddNewContact());

  const onRemove = (index: number) => remove(index);

  const isContactError = !!errors.contacts?.message;

  const { editable } = useFormState();

  return (
    <>
      <CardSection style={{ paddingBottom: 0 }}>
        <FullContainer
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Flex gap={4}>
            <Text variant="HeadingXSmall">{t('agent:pic')}</Text>
            {isContactError && <CircleSVG />}
          </Flex>
          {editable && (
            <Button
              buttonType={isContactError ? 'primary' : 'tertiary'}
              onClick={onAdd}
              startEnhancer={(color, size) => (
                <PlusCircleSVG color={color} size={size} />
              )}
              isError={isContactError}
            >
              {t('common:add')}
            </Button>
          )}
        </FullContainer>
        <SeparatorVertical $margin={16} />
        {fields.map((item, idx) => (
          <SectionContainer key={item.id || item.customId}>
            <OneQuarterContainer>
              <Input
                type="text"
                name={`contacts[${idx}].name`}
                placeholder={t('common:name')}
                label={t('common:name')}
              />
            </OneQuarterContainer>
            <OneQuarterContainer>
              <Input
                type="email"
                name={`contacts[${idx}].email`}
                placeholder={t('common:email')}
                label={t('common:email')}
              />
            </OneQuarterContainer>
            <OneQuarterContainer>
              <Input
                type="tel"
                name={`contacts[${idx}].phone`}
                placeholder={t('common:phone_number')}
                label={t('common:phone_number')}
              />
            </OneQuarterContainer>
            <OneQuarterContainer>
              <Input
                type="text"
                name={`contacts[${idx}].description`}
                placeholder={t('common:description')}
                label={t('common:description')}
              />
            </OneQuarterContainer>
            {editable && (
              <div style={deleteButtonStyle}>
                <DeleteIconButton onClick={() => onRemove(idx)} />
              </div>
            )}
          </SectionContainer>
        ))}
      </CardSection>
    </>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});

const deleteButtonStyle = {
  marginTop: 24,
  width: 34,
  height: 34,
  marginBottom: 16,
};
